import type { GarageMemberResponse } from '../types';

/**
 * Spec 076 — read-only view of a garage member's notification settings (Garage detail → Members):
 * "Off" when the member's switch is off or no channel would deliver, otherwise a badge per channel that
 * is checked AND deliverable, plus a muted hint for a checked channel the contact cannot receive.
 * Admins see it only; the garage's owner or managers change it in the partner portal.
 */
export default function MemberNotificationBadges({ member }: { member: GarageMemberResponse }) {
  const n = member.notifications ?? { enabled: true, whatsapp: true, email: true };
  const whatsappOk = member.whatsappDeliverable !== false;
  const emailOk = member.emailDeliverable !== false;
  const whatsapp = n.enabled && n.whatsapp && whatsappOk;
  const email = n.enabled && n.email && emailOk;
  const noPhone = n.enabled && n.whatsapp && !whatsappOk;
  const noEmail = n.enabled && n.email && !emailOk;

  return (
    <div
      data-testid={`member-notify-${member.id}`}
      style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0.25rem 0.375rem' }}
    >
      {whatsapp && <span className="admin-badge order-info">WhatsApp</span>}
      {email && <span className="admin-badge order-info">Email</span>}
      {!whatsapp && !email && <span className="admin-badge order-neutral">Off</span>}
      {noPhone && <span style={{ fontSize: '0.75rem', color: '#64748b', whiteSpace: 'nowrap' }}>No phone on file</span>}
      {noEmail && <span style={{ fontSize: '0.75rem', color: '#64748b', whiteSpace: 'nowrap' }}>No email on file</span>}
    </div>
  );
}
